import React from "react";
import { isNullOrWhiteSpace } from "../shared/string";
import ReferenceCard, { ReferenceCardProps } from "./ReferenceCard";

export interface RelatedCardsProps {
  cards: ReferenceCardProps[];
  subtitle?: string;
  title?: string;
}

export const RelatedCards = ({ cards, subtitle, title }: RelatedCardsProps) => (
  <aside className="relative z-10">
    {!isNullOrWhiteSpace(title) && <h2 className="text-brand-primary-20">{title}</h2>}

    {!isNullOrWhiteSpace(subtitle) && (
      <h3 className="text-brand-primary-dim text-base uppercase font-bold lg:text-xl lg:mt-2">
        {subtitle}
      </h3>
    )}

    <ul className="pt-2 pb-12 grid gap-4 lg:gap-8 grid-rows-1 grid-flow-col lg:grid-flow-row lg:grid-cols-3 overflow-x-auto">
      {cards.map(card => (
        <ReferenceCard {...card} key={card.id} />
      ))}
    </ul>
  </aside>
);
